import $ from 'jquery';
import urlJoin from 'url-join';

import { initAccordion } from '../../common/accordion';
import { getSearchFormUrl } from '../../common/common.es6';
import Ga from '../../common/ga';
import { typeaheadPlaceFieldDatasets } from '../../common/search';
import HTTPService from '../../common/services/HTTPService.es6';
import { displayErrorToaster } from '../../common/toaster.es6';

function initializeGeoSearchBoxes() {
    // Search a place for accessing a market page
    const $geoSearchBoxes = $('[data-geo-searchbox]');
    if ($geoSearchBoxes.length === 0) {
        return;
    }

    $geoSearchBoxes.each(function geoSearchBoxEach() {
        const $geoSearchBox = $(this);
        const $geoSearchField = $geoSearchBox.find('[data-geo-search-field]');
        $geoSearchField.typeahead(
            {
                hint: true,
                highlight: true,
                minLength: 1,
                autoselect: true,
            },
            typeaheadPlaceFieldDatasets($geoSearchField.data('place-types')),
        );

        $geoSearchField.on('typeahead:selected', (event, place) => {
            const { id, geotype_label: geoTypeLabel } = place;

            HTTPService.getGeo(`${MA.Config.PLACE_TYPE_PLURALS[geoTypeLabel]}/${id}`)
                .then(response => {
                    const geoPlace = response.data.place;

                    // tagging for search suggestions
                    Ga.send({
                        hitType: 'event',
                        eventCategory: 'DVF',
                        eventAction: 'go:dvf_explorer',
                        eventLabel: 'dvf_landing:hero_action_bar:address_suggestion',
                    });

                    getSearchFormUrl(geoPlace)
                        .then(url => {
                            document.location = urlJoin(
                                '/',
                                $geoSearchBox.data('base-url'),
                                url,
                                '/',
                            );
                        })
                        .catch(() => displayErrorToaster('Une erreur est survenue.'));
                })
                .catch(() => {
                    displayErrorToaster('Une erreur est survenue.');
                });
        });

        // prevent form submission when using return to select a place
        $geoSearchField.keypress(e => {
            if (e.keyCode === 13) {
                e.preventDefault();
            }
        });
    });
}

export function domReady() {
    initAccordion('[data-dvf-accordion-button]');
    initializeGeoSearchBoxes();
}
